<template>
  <div class="col" :class="`col-${qtyColumns}`">
    <div class="container--details row col-12">
      <div class="col-5 d-flex align-items-center name" v-if="hasAnalysisName">
        {{
          analysisName.charAt(0).toUpperCase() +
            analysisName.slice(1).toLowerCase()
        }}
      </div>
      <div :class="isScreenLargeOrMedium ? 'col-2' : ''"></div>
      <div
        class="d-flex container--details-spot"
        :class="
          !hasAnalysisName && !isScreenLargeOrMedium
            ? 'flex-row col-12'
            : !hasAnalysisName && isScreenLargeOrMedium
            ? 'flex-column col-12'
            : isScreenLargeOrMedium
            ? 'flex-column col-5'
            : 'flex-row col-7'
        "
      >
        <!-- Spot -->
        <div class="d-flex" style="gap: 5px">
          <div class="results-table-headers align-self-center">
            Spot:
          </div>
          <div class="results-table-headers" style="padding-top: 3px;">
            <span class="text-right" v-show="showLoadingSpot">
              <QSLoading
                :isLoading="showLoadingSpot"
                :size="20"
                :colorTheme="colorTheme"
              />
            </span>
          </div>
          <div
            class="text-right"
            style="color: var(--textactive);
                             font-size: 1.2rem; padding-right: 4px"
            :class="{
              expo: spotAnimate === 1,
              down: spotAnimate === -1
            }"
          >
            {{ spot | priceFormat }}
          </div>
        </div>
        <!-- Date -->
        <div>
          {{ updateDate }}
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { format } from "d3";
import QSLoading from "@/components/QSLoading.vue";

export default {
  name: "DetailsDisplay",
  components: { QSLoading },
  props: {
    analysisName: { required: true, default: "Technical analysis" },
    colorTheme: { required: false, type: Boolean, default: true },
    hasAnalysisName: { required: false, default: true },
    qtyColumns: { required: false, default: 6 },
    showLoadingSpot: { required: false, default: true },
    spot: { required: false, default: null },
    spotAnimate: { required: false, default: 0 },
    updateDate: { required: true, default: new Date() }
  },
  data() {
    return {
      screenWidth: 0,
      isScreenLargeOrMedium: false
    };
  },
  mounted() {
    this.updateScreenWidth();
  },
  methods: {
    updateScreenWidth() {
      this.screenWidth = window.innerWidth;
      if (this.screenWidth > 1440) {
        this.isScreenLargeOrMedium = true;
      }
    }
  },
  filters: {
    priceFormat: function(val) {
      return val === null || val === 0 ? "-" : format(",.6r")(val);
    }
  }
};
</script>

<style scoped>
.container--details,
.container--details-spot {
  padding: 0px;
}
.container--details-spot.flex-column {
  align-items: end;
  justify-content: center;
}
.container--details-spot.flex-row {
  justify-content: end;
  align-items: center;
  gap: 10px;
}
.name {
  font-size: 1rem;
}
@media (max-width: 1280px) {
  .name {
    font-size: 0.9rem;
  }
}
@media (max-width: 1100px) {
  .name {
    font-size: 0.8rem;
  }
}
</style>
